import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d31b428"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { inject, ref, watch } from 'vue';

interface LazyImageProps {
  src: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyImage',
  props: {
    src: null
  },
  setup(__props: any) {



const { onLoad, onError }: any = inject('onLoadOnError');
const show = ref(false);
const error = ref(false);

watch(show, () => {
  if (show.value) {
    onLoad();
  }
});

watch(error, () => {
  if (error.value) {
    onError();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["manifold m-lazy-media lazy-image", { show: show.value }])
  }, [
    _createElementVNode("img", {
      ref: "image",
      src: __props.src,
      onLoad: _cache[0] || (_cache[0] = ($event: any) => (show.value = true)),
      onError: _cache[1] || (_cache[1] = ($event: any) => (error.value = true))
    }, null, 40, _hoisted_1)
  ], 2))
}
}

})